// This file is auto-generated, any changes you make may be overridden
// You should use src/mercuryWebCompat/pages/Treasury/Onboarding/utils.ts to access these values
import {type GeneratedCusip, type TreasuryOnboardingData} from './types'
import {Day} from '~/utils/Calendar'

export const generatedPortfolioData: Record<
  GeneratedCusip | '4812C2734',
  TreasuryOnboardingData
> = {
  // Morgan Stanley MULSX
  '617455696': {
    fundSize: `$11.9B`,
    maturity: `90 days`,
    netYieldPct: 3.824,
    grossYieldPct: 4.69,
    mercuryFeePct: 0.866,
    composition: [
      ['Commercial Paper', 35.55],
      ['Corporate Notes', 27.14],
      ['Repurchase Agreements', 23.26],
      ['Certificates of Deposit', 14.05],
    ],
    updatedAt: new Day(2025, 1, 6),
  },
  // Vanguard VUSXX
  '921932109': {
    fundSize: `$84.6 B`,
    maturity: `34 days`,
    netYieldPct: 3.504,
    grossYieldPct: 4.37,
    mercuryFeePct: 0.866,
    composition: [
      ['U.S. Treasury Bills', 97.6],
      ['U.S. Govt. Obligations', 2.4],
    ],
    updatedAt: new Day(2025, 1, 6),
  },
  // JPMorgan IJTXX
  '4812C2734': {
    fundSize: `$49.69B`,
    maturity: `46 days`,
    netYieldPct: 3.524,
    grossYieldPct: 4.39,
    mercuryFeePct: 0.866,
    composition: [
      ['U.S. Treasury Debt', 76.2],
      ['U.S. Treasury Repurchase Agreement', 23.8],
    ],
    updatedAt: new Day(2025, 1, 6),
  },
} as const
